import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { List } from '@material-ui/core';

import { ProductEntity } from '../../products/Product.interface';
import TaskBulkTransitionListItems from '../components/TaskBulkTransitionListItems';
import TaskBulkActionDialog from '../dialogs/TaskBulkActionDialog';
import { useGroupTaskBulkEvents } from '../Task.hooks';
import {
  TaskBulkEvent,
  TaskBulkEventGroup,
  TaskEntity
} from '../Task.interface';

const StyledList = styled(List)`
  max-width: 640px;
  .sub-header {
    line-height: 1.43;
    padding: 6px 16px;
    .overline {
      line-height: 1.8;
    }
  }
`;

export interface BoardColumnMenuProps {
  taskEntities: TaskEntity[];
  onRender?: () => void;
  onChange?: (processedEntities?: TaskEntity[]) => void;
}

const BoardColumnMenu: React.FC<BoardColumnMenuProps> = ({
  taskEntities,
  onRender,
  onChange
}) => {
  const onRenderRef = useRef(onRender);
  onRenderRef.current = onRender;
  const taskEntitiesRef = useRef(taskEntities);
  taskEntitiesRef.current = taskEntities;
  const [bulkEventGroups, setBulkEventGroups] = useState<TaskBulkEventGroup[]>(
    []
  );
  const [selectedbulkEvent, setSelectedbulkEvent] = useState<TaskBulkEvent>();
  const groupBulkEvents = useGroupTaskBulkEvents();

  useEffect(() => {
    const run = async () => {
      /**
       ** NOTE: id will be changed to use task.key in SLQMS-921
       */
      const groups = await groupBulkEvents(taskEntitiesRef.current, {
        useDeprecatedTaskKey: true
      });
      setBulkEventGroups(groups);
      onRenderRef.current?.();
    };
    run();
  }, [groupBulkEvents]);

  return (
    <StyledList>
      <TaskBulkTransitionListItems
        bulkEventGroups={bulkEventGroups}
        onSelect={setSelectedbulkEvent}
      />
      {selectedbulkEvent && (
        <TaskBulkActionDialog
          open
          bulkEvent={selectedbulkEvent}
          getTitle={taskEntity => (taskEntity as ProductEntity).title}
          onClose={entities => {
            if (entities) {
              onChange?.(entities);
            }
            setSelectedbulkEvent(undefined);
          }}
        />
      )}
    </StyledList>
  );
};

export default BoardColumnMenu;
